module.exports = __webpack_public_path__ + "5f5751693dbcf5547ace4bc9d8ea8c9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/360-2.jpg
// module id = 908
// module chunks = 3